import { ShoppingCart } from 'lucide-react';
import { safeToFixed } from '@paulownia/shared/types';
import type { FloatingCartButtonProps } from './types';

export function FloatingCartButton({ totalItems, total, onClick }: FloatingCartButtonProps) {
    return (
        <button
            onClick={onClick}
            className="fixed bottom-4 left-1/2 -translate-x-1/2 z-20 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-3 font-semibold active:scale-95 transition-all"
        >
            <div className="relative">
                <ShoppingCart className="w-6 h-6" />
                {totalItems > 0 && (
                    <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                        {totalItems > 9 ? '9+' : totalItems}
                    </span>
                )}
            </div>
            <span>Panier</span>
            <span className="font-bold">{safeToFixed(total, 2)}€</span>
        </button>
    );
}
